import { IconsTypesProps } from '../icons/types';

export const ValveScreenIcon2 = ({ width = 58, height = 57 }: IconsTypesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    fill="#637381"
  >
    <rect x="5" y="5" width="90" height="90" stroke="currentColor" strokeWidth="3" fill="none" />

    <line x1="5" y1="95" x2="95" y2="5" stroke="currentColor" strokeWidth="3" fill="#637381" />
  </svg>
);
